import BaseService from '@/services/BaseService';

class EmailLogsService extends BaseService {
    getEmailLogs = (data) => this.post(`/get-email-logs?page=${data.page}&per_page=${data.per_page}`, data || {});

    getEmailContent = (emailId) => this.get(`/get-email-content/${emailId}`);

    downloadData = (data) => this.post('/download-email-logs', data);
}

export default new EmailLogsService();
